import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBox, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const ZoneMaster = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [updateButton, setUpdateButton] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const Hide = false;
    const [formData, setFormData] = useState({
        "zoneID": "0",
        "zoneCode": "",
        "zoneName": "",
        "countryCode": "",
        "active": true
    })

    const handleClear = () => {
        setFormData({
            "zoneID": "0",
            "zoneCode": "",
            "zoneName": "",
            "countryCode": "",
            "active": true
        });
        setUpdateButton(false)
        filterData.SearchText = ''
        getZoneMasterData()
        //inputrefs.current['txtZoneCode'].focus();
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateZoneMaster', formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    }

    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteZoneMaster', { zoneID: ID }, getZoneMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditZoneMaster', { zoneID: id })
        setUpdateButton(true)
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const getZoneMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowZoneMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getZoneMasterData(value);
    };

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    useEffect(() => {
        getZoneMasterData();
    }, [sortConfig])

    useEffect(() => {
        //inputrefs.current['txtZoneCode'].focus();
        document.title = 'Zone Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {FindTranslatedKey('Zone Master')}</h6>
                </div>
                <div className='card-body row'>
                  {/*  {Hide ? <>*/}
                        <div className='row'>
                            <InputBox
                                label='Zone Code'
                                PlaceHolderText='Zone Code'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtZoneCode'
                                value={formData.zoneCode}
                                disabled={disableEdit}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, zoneCode: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtZoneName'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Zone Name'
                                PlaceHolderText='Zone Name'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtZoneName'
                                value={formData.zoneName}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, zoneName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCountry'].focus();
                                    }
                                }}
                            />
                            <AutoCompleteBox
                                label='Country Code'
                                placeholder='Country Code'
                                inputValue={formData.countryCode ? formData.countryCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                        setFormData({ ...formData, countryCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCountry'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtActive'].focus() };
                                }}
                            />
                            <Switch
                                label='Active'
                                inputrefs={inputrefs}
                                id='txtActive'
                                checked={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />
                        </div>
                      {/*</> : <></>}*/}
                  
                    <div className='row pb-1'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/Master/ShowZoneMaster', filterData, 'Zone Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                           // save={false}
                        />
                    </div>
                    <Table handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={'ZoneMaster'}
                        loading={loading}
                        handleFilter={() => {
                            getZoneMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                </div>
            </div>

          
        </>
    )
}

export default ZoneMaster;